import { useEffect } from "react";
import Lenis from "lenis";
import { motion, useScroll } from "framer-motion";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import VideoGallery from "@/components/VideoGallery";
import Lifecycle from "@/components/Lifecycle";
import Brands from "@/components/Brands";
import Industries from "@/components/Industries";
import InquiryForm from "@/components/InquiryForm";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const { scrollYProgress } = useScroll();

  return (
    <>
      <motion.div
        data-testid="scroll-progress"
        className="fixed top-0 left-0 right-0 z-[80] h-[2px] origin-left bg-crimson"
        style={{ scaleX: scrollYProgress }}
      />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <VideoGallery />
        <Lifecycle />
        <Brands />
        <Industries />
        <InquiryForm />
      </main>
      <Footer />
      <ChatWidget />
      <WhatsAppButton />
    </>
  );
}
